import { render, staticRenderFns } from "./BaseSvg.vue?vue&type=template&id=597f2545"
import script from "./BaseSvg.vue?vue&type=script&lang=js"
export * from "./BaseSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports